var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"player_list"},_vm._l((_vm.players),function(player){return _c('PlayerListItem',{key:player.id,staticClass:"p_player_list_item",attrs:{"data":_vm.getPlayerItemData(player.id)}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }